const isVoucherOwner = (createdBy?: string | null, userEmail?: string | null): boolean =>
  !!createdBy && !!userEmail && createdBy.toLowerCase() === userEmail.toLowerCase();

export default isVoucherOwner;
